var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponent,_vm._b({tag:"component",attrs:{"data-component":"drawer-item"},on:{"click":_vm.click}},'component',_vm.getProps,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }